import React from 'react';
import { Button } from '../Button';
import Icon from '../Icon';

const ConfiguracoesListagemFilterActions = ({
  onAbrirConfiguracoes,
  onSalvarConfiguracao,
  loading,
  podeSalvarGeral = false
}) => (
  <>
    <Button
      variant="outline-secondary"
      size="sm"
      type="button"
      onClick={onAbrirConfiguracoes}
      disabled={loading}
    >
      <Icon name="settings" size={14} />
      <span>Configuracoes</span>
    </Button>

    {podeSalvarGeral && (
      <Button
        variant="outline-primary"
        size="sm"
        type="button"
        onClick={onSalvarConfiguracao}
        disabled={loading}
      >
        <Icon name="star" size={14} />
        <span>Salvar configuracao</span>
      </Button>
    )}
  </>
);

export default ConfiguracoesListagemFilterActions;
